"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCardPrintable;
const designs_1 = require("../../designs");
const createPrintable_1 = __importDefault(require("../createPrintable"));
const EditableTextLayer_1 = require("../../../models/layers/EditableTextLayer");
const __1 = require("..");
const getTemplateSurface_1 = require("../getTemplateSurface");
function createCardPrintable(_ref) {
  let {
    userId,
    projectId,
    creationDate,
    template,
    printableGroupType,
    designId,
    printableId
  } = _ref;
  const getDesignResult = (0, designs_1.findMatchingOrDefaultDesign)({
    newTemplateDesigns: template.designs,
    designId,
    printableGroupType
  });
  if (getDesignResult.isLeft()) {
    throw getDesignResult.value;
  }
  const layersResult = (0, designs_1.getLayersForDesign)({
    template,
    design1: getDesignResult.value
  });
  if (layersResult.isLeft()) {
    throw layersResult.value;
  }
  const layers = layersResult.value;
  layers.forEach(layer => {
    if ((0, EditableTextLayer_1.isEditableTextLayer)(layer) && layer.defaultData.content) {
      const surface = (0, getTemplateSurface_1.getTemplateSurface)({
        template,
        printableGroupType
      });
      (0, __1.createDefaultLayers)(layer, surface);
    }
  });
  const createPrintableResult = (0, createPrintable_1.default)(userId, projectId, getDesignResult.value.id, layersResult.value, template, printableId, creationDate, printableGroupType);
  if (createPrintableResult.isLeft()) {
    throw createPrintableResult.value;
  }
  return createPrintableResult.value;
}